// 邮箱绑定
<template>
  <Card title="邮箱">
    <template slot="content">
      <div class="content show" v-if="show">
        <div class="tip">
          <i class="iconfont icon-youxiang"></i>
          {{ mail || "未绑定" }}
          <!-- <span class="value danger" v-if="mail.state == -1"
            >未绑定
            <i class="iconfont icon-anquanshezhi"></i>
          </span>
          <span class="value warn" v-else-if="mail.state == 0"
            >未验证
            <i class="iconfont icon-guanyu"></i>
          </span>
          <span class="value success" v-else-if="mail.state == 1"
            >已验证 <i class="iconfont icon-querenmima"></i
          ></span> -->
        </div>
        <div class="goBuy-btn-box">
          <MButton class="goBuy-btn" @click="show = !show">{{
            changeMail ? "修改" : "绑定"
          }}</MButton>
        </div>
      </div>
      <div class="content change" v-else>
        <div class="chane_input">
          <MInput
            v-model="newMail"
            placeholder="邮箱地址"
            icon="icon-youxiang"
          ></MInput>
        </div>
        <div class="submit-btn">
          <MButton class="btn cancel" @click="show = !show">取消</MButton>
          <MButton
            class="btn submit"
            :disabled="canISubmit"
            :loading="loading"
            @click="changeMail"
            >确认</MButton
          >
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import Card from "@/components/common/Card";
import MInput from "@/components/common/Input";
import MButton from "@/components/common/Button";

import { upUserMail } from "@/api/user";

export default {
  components: {
    Card,
    MInput,
    MButton,
  },
  data() {
    return {
      show: true,
      newMail: "",
      loading: false,
    };
  },
  computed: {
    canISubmit: function () {
      return this.newMail == "";
    },
    mail: function () {
      return this.$store.getters.getUserInfo.mail;
    },
  },
  methods: {
    changeMail() {
      this.$utils.throttle(() => {
        this.loading = true;
        upUserMail({ mail: this.newMail }).then(
          (res) => {
            this.loading = false;
            this.$store.commit("upUserInfo", { mail: this.newMail });
            this.newMail = "";
            this.$tip.success("绑定邮箱成功!", 4000);
            this.show = true;
          },
          (err) => {
            this.loading = false;
          }
        );
        setTimeout(() => {
          // todo 发起请求
        }, 1000);
      }, 10000);
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.show {
  .tip {
    .warn {
      color: #e6a23c;
    }
    .danger {
      color: #f56c6c;
    }
    .success {
      color: #67c23a;
    }
  }
  .goBuy-btn-box {
    width: 50%;
    margin: 0 auto;
  }
  .goBuy-btn {
    background: #5932ea;
    color: #fff;
    &:hover {
      filter: brightness(1.2);
    }
  }
}
.change {
  .submit-btn {
    display: flex;
    justify-content: space-around;
    .btn {
      width: 30%;
      padding: 0.5rem;
    }
    .submit {
      background: #5932ea;
      color: #fff;
    }
  }
}
</style>
